import axios from "axios";
import { de } from "date-fns/locale";

const apiUrl = process.env.REACT_APP_API_URL;

const VehicleService = {
    async getAllVehicles() {
        try {
            const result = await axios.get(`${apiUrl}/Vehicle`);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },
    
    async saveVehivle(vehicle) {
        try {
            const result = await axios.post(`${apiUrl}/Vehicle`, vehicle);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async getDriversMission(directionId = null){
        try{
            const url = directionId ? `${apiUrl}/Vehicle/drivers/${directionId}` : `${apiUrl}/Vehicle/drivers`;
            const result = await axios.get(url);
              if (result) {
                return result.data;
              }
        }catch(err){
            if(err.response){
                return err.response.data;
              }
        }
    },

    async getVehicle(id){
        try{
            const result = await axios.get(`${apiUrl}/Vehicle/vehicle/${id}`);
            if(result){
                return result.data;
            }
        } catch (err){
            if(err.response){
                return err.response.data;
              }
        }
    },

    async filterVehicles (filter){
        try {
            const result = await axios.post(`${apiUrl}/Vehicle/filterVehicles`, {
                filterData:filter
            });
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async deleteVehicle(id){
        try {
            const result = await axios.delete(`${apiUrl}/Vehicle/${id}`);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },
    async getvehiclesAvalaible(begin, end, transport_id = null, vhc_id = null, direction_id = null){
        try {
            let payload = {
                begin: begin,
                end: end
            };

            if (transport_id && typeof transport_id === 'object' && !Array.isArray(transport_id)) {
                payload = {
                    ...payload,
                    ...transport_id
                };
            } else {
                payload = {
                    ...payload,
                    transport_id: transport_id,
                    vhc_id: vhc_id,
                    direction_id: direction_id
                };
            }
            const result = await axios.post(`${apiUrl}/Vehicle/vehiclesAvalaible`, {
                ...payload
            });
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
       
    },

    async vehicleDataByTransportId(transportId){
        try {
            const result = await axios.get(`${apiUrl}/Vehicle/vehicleDataByTransport/${transportId}`);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async disponibilityVehicle(filter){
        try {
            const result = await axios.post(`${apiUrl}/Vehicle/disponibility/`, {
                filter
            });
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async vehicleByDirection(directionId){
        try {
            const result = await axios.get(`${apiUrl}/Vehicle/vehicleByDirection/${directionId}`);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async getFuelParameters() {
        try {
            const result = await axios.get(`${apiUrl}/Vehicle/fuelPricesList`);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async saveFuelParameter(fuelParameter) {
        try {
            const result = await axios.post(`${apiUrl}/Vehicle/fuelPrice`, fuelParameter);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },

    async deleteFuelParameter(fuel_price_id) {
        try {
            const result = await axios.delete(`${apiUrl}/Vehicle/fuelPrice/${fuel_price_id}`);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },
    async driversByUser(){
        try{
            const result = await axios.get(`${apiUrl}/Vehicle/driversByUser`);
            if(result){
                return result.data;            }
        } catch (error){
            return error.response.data;
        }
    },
    async currentFuelPrice(vhc_type){
        try{
            const result = await axios.get(`${apiUrl}/Vehicle/currentFuelPrice/${vhc_type}`);
            if(result){
                return result.data;            }
        } catch (error){
            return error.response.data;
        }
    },

};

export default VehicleService;
